module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Light.779f3bf4.otf";